import type { PlanName } from '~/composables/usePlanConfig'
import { LazyPlanUpgradeModal } from '#components'

/** Injection key for an optional save function provided by the customize page. */
export const PLAN_GATE_SAVE_KEY = Symbol('planGateSave') as InjectionKey<() => Promise<void>>

/**
 * Composable that shows an upgrade modal when a user tries to use a locked feature.
 * If the user clicks "Upgrade", it saves (on customize page) then navigates to billing.
 */
export function usePlanGate() {
  const overlay = useOverlay()
  const saveBeforeLeave = inject(PLAN_GATE_SAVE_KEY, null)

  const upgradeModal = overlay.create(LazyPlanUpgradeModal)

  async function requirePlan(feature: string, requiredPlan: PlanName) {
    const instance = upgradeModal.open({ feature, requiredPlan })
    const wantsUpgrade = await instance.result

    if (wantsUpgrade) {
      if (saveBeforeLeave) {
        try {
          await saveBeforeLeave()
        } catch {
          // Save failed - still navigate so the user can upgrade
        }
      }
      await navigateTo('/dashboard/settings/billing')
    }
  }

  return { requirePlan }
}
